import './App.css';
import React from 'react'
import {BrowserRouter as Router} from 'react-router-dom'
import Routes from './Routes'
import IntlProviderConfigured from './i18n/IntlProviderConfigured'
import NavBar from './components/NavBar'


function App() {
  return (
    <div className="app">
      <IntlProviderConfigured>
        <Router>
          <NavBar></NavBar>
          <Routes/>
        </Router>
      </IntlProviderConfigured>
    </div>
  );
}

export default App;
